import { ContentfulEntry } from '@jbhi-fi/apis/src/contentful/types';
import { ListingBlockTransformer } from '../../Contentful/transformers/ListingBlockTransformer';
import { ContentBlockProps } from '../../ContentBlock/ContentBlock';
import { ArticleBlockTransformer } from '../../Contentful/transformers/ArticleBlockTransformer';
import { CarouselTransformer } from '../../Contentful/transformers/CarouselTransformer/CarouselTransformer';
import { ProductBlockTransformer } from '../../Contentful/transformers/ProductBlockTransformer';
import { PromoCardTransformer } from '../../Contentful/transformers/PromoCardTransformer';
import { SectionTransformer } from '../../Contentful/transformers/SectionTransformer';

type EntryContentBlockProps =
  | Partial<ContentBlockProps>
  | ((entry: ContentfulEntry<any>) => Partial<ContentBlockProps> | undefined);

export const getContentEntryBlocks = (options?: { isLoggedIn?: boolean }): Record<string, EntryContentBlockProps> => {
  return {
    listingBlock: ListingBlockTransformer.toContentBlockProps,
    articleBlock: ArticleBlockTransformer.toContentBlockProps,
    productBlock: ProductBlockTransformer.toContentBlockProps,
    carousel: CarouselTransformer.toContentBlockProps,
    promoCard: e => PromoCardTransformer.toContentBlockProps(e, { isLoggedIn: options?.isLoggedIn }),
    contactBlock: {
      paddingY: 0,
      paddingBottom: 1,
    },
    leaderboardBanner: {
      paddingY: 7.5,
    },
    section: SectionTransformer.toContentBlockProps,
  };
};
